package com.schoolconnect.app.datasource.network.request

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ExamResultSummaryRequest(
    val total: Double,
    @SerialName("total_percentage") val totalPercentage: Double,
    val grade: String? = null,
    val rank: Int? = null,
    val notes: String? = null
)

@Serializable
data class ExamResultSubjectMarkRequest(
    @SerialName("subject_id") val subjectId: String,
    val internal: Double,
    val main: Double,
    val total: Double,
    val grade: String? = null,
    val rank: Int? = null
)

@Serializable
data class ExamResultBulkEntryItemRequest(
    @SerialName("student_id") val studentId: String,
    @SerialName("roll_number") val rollNumber: String? = null,
    val name: String? = null,
    val summary: ExamResultSummaryRequest,
    @SerialName("subject_marks") val subjectMarks: List<ExamResultSubjectMarkRequest>
)

@Serializable
data class ExamResultBulkEntryRequest(
    @SerialName("exam_id") val examId: String,
    val status: String = "DRAFT",
    val results: List<ExamResultBulkEntryItemRequest>
)
